import React from "react";
import { Link } from "react-router-dom"; 
import { FaMapMarkerAlt, FaEnvelopeOpen, FaFacebookF } from "react-icons/fa";
import { AiOutlineGoogle } from "react-icons/ai";
import { BsTwitter, BsInstagram } from "react-icons/bs";

const Footer = () => {
  return (
    <>
      <footer className="theme-dark-bg">
        <div className="tp-footer-area-two pt-80 pb-50">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-1 mb-30 wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="tp-footer-info">
                    <div className="tp-footer-info-logo mb-35">
                      <Link to="/">
                        <img
                          src="assets/img/logo/logo-white.png"
                          className="img-fluid"
                          alt="img not found"
                        />
                      </Link>
                    </div>
                    <h4 className="mb-15">
                      <a href="tel:+237687788330">687 78 83 30</a>
                    </h4>
                    <h6 className="mb-15">
                      {" "}
                      <i>
                        {" "}
                        <FaEnvelopeOpen />{" "}
                      </i>
                      <a href="mailto:contact@hg-services.com">
                        contact@hg-services.com
                      </a>
                    </h6>
                    <h6 className="mb-20">
                      {" "}
                      <i>
                        {" "}
                        <FaMapMarkerAlt />{" "}
                      </i>{" "}
                      YATCHIKA GSB CHANTEVA, Douala Cameroun
                    </h6>
                    {false && (
                      <div className="tp-footer-info-social">
                        <a href="/">
                          <i>
                            <FaFacebookF className="icon" />{" "}
                          </i>
                        </a>
                        <a href="/">
                          <i>
                            <BsTwitter className="icon" />{" "}
                          </i>
                        </a>
                        <a href="/">
                          <i>
                            <BsInstagram className="icon" />{" "}
                          </i>
                        </a>
                        <a href="/">
                          <i>
                            <AiOutlineGoogle className="icon" />{" "}
                          </i>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-2 mb-30 wow fadeInUp"
                  data-wow-delay=".6s"
                >
                  <h4 className="tp-footer-widget-title mb-35">Nos Services</h4>
                  <ul>
                    <li>
                      <a href="#">Nettoyage de tapis</a>
                    </li>
                    <li>
                      <a href="#">Services de plomberie</a>
                    </li>
                    <li>
                      <a href="#">Nettoyage du parc</a>
                    </li>
                    <li>
                      <a href="#">Residentiel Services</a>
                    </li>
                    <li>
                      <a href="#">Nettoyage des toilettes</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-3 mb-30 wow fadeInUp"
                  data-wow-delay=".9s"
                >
                  <h4 className="tp-footer-widget-title mb-35">
                    Formulaire de contact
                  </h4>
                  <div className="tp-footer-news">
                    <div className="tp-footer-news-single mb-15">
                      <h6>
                        <Link to="/blogDetails">Cliquez et ecrivez nous</Link>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div
                  className="tp-footer-widget footer-col-4 mb-30 wow fadeInUp"
                  data-wow-delay="1.2s"
                >
                  <h4 className="tp-footer-widget-title mb-40">
                    Images en action
                  </h4>
                  <div className="tp-footer-insta">
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-1.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-2.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-3.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-4.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-5.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                    <a href="/">
                      <img
                        src="assets/img/footer/footer-insta-6.jpg"
                        className="img-fluid"
                        alt="img not found"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-copyright-area-two bg-green-light z-index pt-30 pb-30">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-copyright tp-copyright-two text-center">
                  <p className="m-0">
                    Copyright ©2021 <span>hg-services</span>. Tous droits
                    réservés Copyright
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
